import type { ParsedEquipment } from '@t/equipmentOffering.types';

// ---------------------------------------------------------------------------
// Equipment Pop-up Decision Logic
// ---------------------------------------------------------------------------

export type EquipmentPopupAction = 'show' | 'skip' | 'auto-add';

/**
 * Determines whether to show the equipment selection popup, skip it,
 * or auto-add the single free equipment.
 *
 * Decision matrix (from Jira AC):
 *  - Empty array              → skip
 *  - Exactly 1, price === 0   → auto-add
 *  - Exactly 1, price > 0     → show
 *  - More than 1              → show
 */
export const determineEquipmentPopupAction = (equipments: ParsedEquipment[]): EquipmentPopupAction => {
  if (equipments.length === 0) return 'skip';
  if (equipments.length === 1 && equipments[0].price === 0) return 'auto-add';
  return 'show';
};

/**
 * Returns the single free equipment when the action is 'auto-add', otherwise null.
 */
export const getAutoAddEquipment = (equipments: ParsedEquipment[]): ParsedEquipment | null => {
  if (determineEquipmentPopupAction(equipments) === 'auto-add') {
    return equipments[0];
  }
  return null;
};

/**
 * Returns true when there are optional add-ons available to show.
 */
export const hasAvailableAddOns = (addOns: unknown[]): boolean => addOns.length > 0;
